/** @typedef {{ to: string, labelId: string, end?: boolean }} SuiteNavItem */

/** @type {Record<string, SuiteNavItem[]>} */
const NAV = {
  main: [
    { to: ".", labelId: "suite.nav.overview", end: true },
    { to: "notifications", labelId: "suite.main.notifications" },
    { to: "search", labelId: "suite.main.search" },
    { to: "shortcuts", labelId: "suite.main.shortcuts" }
  ],
  ticketing: [
    { to: ".", labelId: "suite.nav.overview", end: true },
    { to: "tickets", labelId: "suite.ticketing.tickets" },
    { to: "customers", labelId: "suite.ticketing.customers" },
    { to: "macros", labelId: "suite.ticketing.macros" },
    { to: "sla", labelId: "suite.ticketing.sla" }
  ],
  blogging: [
    { to: ".", labelId: "suite.nav.overview", end: true },
    { to: "posts", labelId: "suite.blogging.posts" },
    { to: "categories", labelId: "suite.blogging.categories" },
    { to: "media", labelId: "suite.blogging.media" },
    { to: "comments", labelId: "suite.blogging.comments" }
  ],
  storage: [
    { to: ".", labelId: "suite.nav.overview", end: true },
    { to: "files", labelId: "suite.storage.files" },
    { to: "shares", labelId: "suite.storage.shares" },
    { to: "settings", labelId: "suite.storage.settings" }
  ],
  adverts: [
    { to: ".", labelId: "suite.nav.overview", end: true },
    { to: "campaigns", labelId: "suite.adverts.campaigns" },
    { to: "reports", labelId: "suite.adverts.reports" },
    { to: "billing", labelId: "suite.adverts.billing" }
  ],
  "saas-crm": [
    { to: ".", labelId: "suite.nav.overview", end: true },
    { to: "deals", labelId: "suite.crm.deals" },
    { to: "accounts", labelId: "suite.crm.accounts" },
    { to: "contacts", labelId: "suite.crm.contacts" },
    { to: "activities", labelId: "suite.crm.activities" }
  ],
  analytics: [
    { to: ".", labelId: "suite.nav.overview", end: true },
    { to: "reports", labelId: "suite.analytics.reports" },
    { to: "builder", labelId: "suite.analytics.builder" },
    { to: "exports", labelId: "suite.analytics.exports" }
  ],
  ecommerce: [
    { to: ".", labelId: "suite.nav.overview", end: true },
    { to: "products", labelId: "suite.ecom.products" },
    { to: "orders", labelId: "suite.ecom.orders" },
    { to: "customers", labelId: "suite.ecom.customers" },
    { to: "returns", labelId: "suite.ecom.returns" }
  ],
  finance: [
    { to: ".", labelId: "suite.nav.overview", end: true },
    { to: "invoices", labelId: "suite.finance.invoices" },
    { to: "payments", labelId: "suite.finance.payments" },
    { to: "expenses", labelId: "suite.finance.expenses" },
    { to: "budgets", labelId: "suite.finance.budgets" }
  ],
  industrial: [
    { to: ".", labelId: "suite.nav.overview", end: true },
    { to: "assets", labelId: "suite.industrial.assets" },
    { to: "alerts", labelId: "suite.industrial.alerts" },
    { to: "work-orders", labelId: "suite.industrial.workorders" }
  ],
  "ai-studio": [
    { to: ".", labelId: "suite.nav.overview", end: true },
    { to: "projects", labelId: "suite.aistudio.projects" },
    { to: "keys", labelId: "suite.aistudio.keys" },
    { to: "logs", labelId: "suite.aistudio.logs" },
    { to: "experiments", labelId: "suite.aistudio.experiments" },
    { to: "settings", labelId: "suite.aistudio.settings" }
  ],
  devops: [
    { to: ".", labelId: "suite.nav.overview", end: true },
    { to: "services", labelId: "suite.devops.services" },
    { to: "incidents", labelId: "suite.devops.incidents" },
    { to: "deploys", labelId: "suite.devops.deploys" },
    { to: "runbooks", labelId: "suite.devops.runbooks" },
    { to: "oncall", labelId: "suite.devops.oncall" }
  ],
  "subscription-plg": [
    { to: ".", labelId: "suite.nav.overview", end: true },
    { to: "accounts", labelId: "suite.plg.accounts" },
    { to: "trials", labelId: "suite.plg.trials" },
    { to: "features", labelId: "suite.plg.features" },
    { to: "churn", labelId: "suite.plg.churn" }
  ],
  "hr-people": [
    { to: ".", labelId: "suite.nav.overview", end: true },
    { to: "employees", labelId: "suite.hr.employees" },
    { to: "requisitions", labelId: "suite.hr.requisitions" },
    { to: "timeoff", labelId: "suite.hr.timeoff" },
    { to: "settings", labelId: "suite.hr.settings" }
  ],
  logistics: [
    { to: ".", labelId: "suite.nav.overview", end: true },
    { to: "shipments", labelId: "suite.logistics.shipments" },
    { to: "carriers", labelId: "suite.logistics.carriers" },
    { to: "warehouses", labelId: "suite.logistics.warehouses" },
    { to: "exceptions", labelId: "suite.logistics.exceptions" }
  ],
  healthcare: [
    { to: ".", labelId: "suite.nav.overview", end: true },
    { to: "appointments", labelId: "suite.health.appointments" },
    { to: "claims", labelId: "suite.health.claims" },
    { to: "providers", labelId: "suite.health.providers" }
  ],
  education: [
    { to: ".", labelId: "suite.nav.overview", end: true },
    { to: "courses", labelId: "suite.edu.courses" },
    { to: "cohorts", labelId: "suite.edu.cohorts" },
    { to: "learners", labelId: "suite.edu.learners" }
  ],
  "real-estate": [
    { to: ".", labelId: "suite.nav.overview", end: true },
    { to: "listings", labelId: "suite.re.listings" },
    { to: "leads", labelId: "suite.re.leads" },
    { to: "transactions", labelId: "suite.re.transactions" }
  ],
  security: [
    { to: ".", labelId: "suite.nav.overview", end: true },
    { to: "vulns", labelId: "suite.sec.vulns" },
    { to: "policies", labelId: "suite.sec.policies" },
    { to: "audit", labelId: "suite.sec.audit" }
  ]
};

/** Sidebar: vertical order + labels (Offcanvas). Keys must exist on {@link NAV}. */
export const DASHBOARD_SUITE_ORDER = [
  { key: "main", labelId: "menu.dashboard", iconClassName: "fa fa-luggage-cart font-color-1 me-1" },
  { key: "ticketing", labelId: "menu.ticketing", iconClassName: "fa fa-users mr-1 font-color-1" },
  { key: "blogging", labelId: "menu.blogging", iconClassName: "far fa-edit mr-1 font-color-1" },
  { key: "storage", labelId: "menu.storage", iconClassName: "fa fa-cloud-upload-alt mr-1 font-color-1" },
  { key: "adverts", labelId: "menu.adverts", iconClassName: "fab fa-buysellads mr-2 font-color-1" },
  { key: "saas-crm", labelId: "menu.saas-crm", iconClassName: "fa fa-briefcase mr-1 font-color-1" },
  { key: "analytics", labelId: "menu.analytics", iconClassName: "fa fa-chart-pie mr-1 font-color-1" },
  { key: "ecommerce", labelId: "menu.ecommerce", iconClassName: "fa fa-store mr-1 font-color-1" },
  { key: "finance", labelId: "menu.finance", iconClassName: "fa fa-university mr-1 font-color-1" },
  { key: "industrial", labelId: "menu.industrial", iconClassName: "fa fa-cogs mr-1 font-color-1" },
  { key: "ai-studio", labelId: "menu.ai-studio", iconClassName: "fa fa-robot mr-1 font-color-1" },
  { key: "devops", labelId: "menu.devops", iconClassName: "fa fa-server mr-1 font-color-1" },
  {
    key: "subscription-plg",
    labelId: "menu.subscription-plg",
    iconClassName: "fa fa-chart-line mr-1 font-color-1"
  },
  { key: "hr-people", labelId: "menu.hr-people", iconClassName: "fa fa-sitemap mr-1 font-color-1" },
  { key: "logistics", labelId: "menu.logistics", iconClassName: "fa fa-truck mr-1 font-color-1" },
  { key: "healthcare", labelId: "menu.healthcare", iconClassName: "fa fa-heartbeat mr-1 font-color-1" },
  { key: "education", labelId: "menu.education", iconClassName: "fa fa-graduation-cap mr-1 font-color-1" },
  { key: "real-estate", labelId: "menu.real-estate", iconClassName: "fa fa-building mr-1 font-color-1" },
  { key: "security", labelId: "menu.security", iconClassName: "fa fa-lock mr-1 font-color-1" }
];

export type SuiteVertical = keyof typeof NAV;
export type SuiteNavItem = (typeof NAV)[SuiteVertical][number];

export function suiteAbsolutePath(
  suiteKey: string,
  item: Pick<SuiteNavItem, "to"> | null | undefined
) {
  const base = `/app/main/layout/${suiteKey}`;
  if (!item || item.to === ".") {
    return base;
  }
  return `${base}/${item.to}`;
}

export function getSuiteNav(vertical: string): SuiteNavItem[] | undefined {
  if (Object.prototype.hasOwnProperty.call(NAV, vertical)) {
    return NAV[vertical as SuiteVertical];
  }
  return undefined;
}
